export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-secondary-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">Buyer Reviews</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Trusted by Global Shoppers
          </h2>
          <p className="text-base text-foreground-500 mt-3">
            What users are saying about their experience with the spreadsheet shopping system
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl p-6 border border-background-200/50"
            >
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h4 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                {t.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {t.review}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const testimonials = [
  {
    title: 'Best buying guide I found',
    review: 'The OOPBuy Spreadsheet system completely changed how I organize my shopping. Being able to compare multiple products side by side in a structured format saves me so much time every week.',
    name: 'Sarah Mitchell',
    role: 'Frequent Online Shopper',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20in%20her%2030s%20with%20warm%20genuine%20smile%2C%20soft%20natural%20window%20lighting%2C%20clean%20white%20background%2C%20headshot%20photography%2C%20modern%20professional%20attire%20in%20sage%20green%2C%20friendly%20approachable%20expression%2C%20high%20quality%20corporate%20portrait&width=100&height=100&seq=avatar-sarah-v2&orientation=squarish',
  },
  {
    title: 'So easy to navigate',
    review: 'I never thought organizing purchases could be this straightforward. The spreadsheet layout makes everything visible at a glance, and I can make decisions much faster than browsing individual sites.',
    name: 'James Cooper',
    role: 'Small Business Owner',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%2040s%20with%20confident%20warm%20expression%2C%20natural%20daylight%20illumination%2C%20clean%20grey%20background%2C%20headshot%20photography%2C%20dark%20navy%20blazer%2C%20trustworthy%20leadership%20look%2C%20corporate%20portrait%20style&width=100&height=100&seq=avatar-james-v2&orientation=squarish',
  },
  {
    title: 'Great for comparing prices',
    review: 'As someone who buys in bulk, the price comparison feature is invaluable. I can spot the best deals across multiple sellers without opening dozens of browser tabs. Highly recommend.',
    name: 'Emily Roberts',
    role: 'Reseller &amp; Entrepreneur',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20woman%20with%20bright%20authentic%20smile%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20headshot%20photography%2C%20modern%20burgundy%20top%2C%20energetic%20entrepreneur%20vibe%2C%20warm%20friendly%20expression&width=100&height=100&seq=avatar-emily-v2&orientation=squarish',
  },
  {
    title: 'Saves me hours each month',
    review: 'The structured approach to product management means I spend less time hunting for deals and more time actually enjoying what I buy. The system is intuitive and well-designed.',
    name: 'Michael Chen',
    role: 'Tech Reviewer',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%2030s%20with%20relaxed%20confident%20smile%2C%20natural%20window%20light%2C%20clean%20white%20background%2C%20headshot%20photography%2C%20casual%20charcoal%20sweater%2C%20friendly%20approachable%20tech%20professional%20look&width=100&height=100&seq=avatar-michael-v2&orientation=squarish',
  },
  {
    title: 'Perfect for organized shopping',
    review: 'I love how everything is laid out in a clean spreadsheet format. No clutter, no confusion — just clear product data that helps me make quick, confident purchasing decisions every time.',
    name: 'Olivia Williams',
    role: 'Lifestyle Blogger',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20in%20her%2020s%20with%20radiant%20natural%20smile%2C%20golden%20hour%20window%20light%2C%20clean%20background%2C%20headshot%20photography%2C%20cream%20colored%20blouse%2C%20creative%20professional%20aesthetic%2C%20warm%20and%20genuine%20expression&width=100&height=100&seq=avatar-olivia-v2&orientation=squarish',
  },
  {
    title: 'Beginner-friendly system',
    review: 'I was new to spreadsheet-based shopping and worried it would be complicated. Turned out to be incredibly user-friendly. The learning curve is minimal and the results are immediate.',
    name: 'Daniel Park',
    role: 'First-Time User',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%2020s%20with%20warm%20friendly%20smile%2C%20natural%20studio%20lighting%2C%20clean%20beige%20background%2C%20headshot%20photography%2C%20olive%20green%20casual%20shirt%2C%20youthful%20professional%20look%2C%20trustworthy%20expression&width=100&height=100&seq=avatar-daniel-v2&orientation=squarish',
  },
  {
    title: 'Transparent and reliable',
    review: 'The transparency of the spreadsheet format gives me confidence in my buying decisions. No hidden details — everything is presented clearly so I know exactly what I am getting.',
    name: 'Sophia Martinez',
    role: 'Verified Buyer',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20in%20her%2030s%20with%20confident%20calm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20headshot%20photography%2C%20navy%20blouse%2C%20polished%20corporate%20look%2C%20trustworthy%20professional%20expression&width=100&height=100&seq=avatar-sophia-v2&orientation=squarish',
  },
  {
    title: 'Makes bulk buying easy',
    review: 'Managing large orders across multiple categories used to be a headache. The OOPBuy Spreadsheet system centralizes everything and makes bulk purchasing remarkably efficient.',
    name: 'Alex Thompson',
    role: 'Wholesale Buyer',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%2040s%20with%20friendly%20confident%20smile%2C%20warm%20natural%20window%20light%2C%20clean%20grey%20background%2C%20headshot%20photography%2C%20tan%20blazer%20over%20white%20shirt%2C%20business%20casual%20professional%2C%20approachable%20demeanor&width=100&height=100&seq=avatar-alex-v2&orientation=squarish',
  },
  {
    title: 'My go-to shopping tool',
    review: 'I have tried various shopping comparison tools, and this spreadsheet system is by far the most intuitive and effective. It has become an essential part of my online shopping routine.',
    name: 'Lauren Davis',
    role: 'Regular User',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20in%20her%2020s%20with%20bright%20natural%20smile%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20headshot%20photography%2C%20terracotta%20colored%20top%2C%20creative%20casual%20professional%2C%20warm%20genuine%20expression&width=100&height=100&seq=avatar-lauren-v2&orientation=squarish',
  },
];